import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Phone, Check, AlertCircle } from "lucide-react";

export default function AdminContacts() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/contacts").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="admin-contacts">
      <div className="mb-10">
        <span className="font-overline text-[#B8935A]">Back-office</span>
        <h1 className="font-serif text-3xl text-[#0F172A] mt-2">Messages reçus</h1>
        <p className="text-[#64748B] mt-2 text-sm">
          Tous les messages envoyés via le formulaire de contact du site.
        </p>
      </div>

      <div className="space-y-4">
        {items.map((c) => (
          <div key={c.id} className="bg-white border border-[#E2E8F0] p-6" data-testid={`admin-contact-${c.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="font-serif text-lg text-[#0F172A]">
                  {c.prenom} {c.nom}
                </div>
                <div className="flex flex-wrap gap-4 mt-2 text-sm text-[#64748B]">
                  <a href={`mailto:${c.email}`} className="flex items-center gap-1.5 hover:text-[#B8935A]">
                    <Mail size={14} /> {c.email}
                  </a>
                  {c.telephone && (
                    <a href={`tel:${c.telephone}`} className="flex items-center gap-1.5 hover:text-[#B8935A]">
                      <Phone size={14} /> {c.telephone}
                    </a>
                  )}
                </div>
              </div>
              <div className="text-right text-xs text-[#94A3B8]">
                <div>{new Date(c.created_at).toLocaleString("fr-FR")}</div>
                <div className="mt-2">
                  {c.email_sent ? (
                    <span className="inline-flex items-center gap-1 text-[#15803D]">
                      <Check size={12} /> Email envoyé
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1 text-[#B45309]">
                      <AlertCircle size={12} /> Email non envoyé
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-[#E2E8F0] text-[#1E293B] text-sm whitespace-pre-wrap leading-relaxed">
              {c.message}
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <div className="bg-white border border-[#E2E8F0] p-16 text-center text-[#64748B]">
            Aucun message reçu pour le moment.
          </div>
        )}
      </div>
    </div>
  );
}
